import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/shared/api/client';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { MailCheck } from 'lucide-react';
// Le logo et le nom suivent le domaine d'arrivee : ces deux pages sont servies
// par cftsign.fr, ou une invitation par courriel depose le poseur.
import { IDENTITE } from '@/shared/marque';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot', { email });
    } catch {
      // Anti-énumération : on affiche le même message quoi qu'il arrive.
    }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-4" data-testid="forgot-page">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="text-center mb-10">
          <img src={IDENTITE.logo} alt={IDENTITE.nom} className="w-12 h-12 rounded-xl mx-auto mb-4" />
          <h1 className="text-xl font-semibold tracking-tight text-neutral-900">Mot de passe oublié</h1>
        </div>

        {sent ? (
          <div className="text-center space-y-4">
            <MailCheck className="w-10 h-10 text-emerald-500 mx-auto" />
            <p className="text-sm text-neutral-600">
              Si un compte est associé à cette adresse, un email de réinitialisation vient d'être envoyé.
              Pensez à vérifier vos spams.
            </p>
            <Link to="/login" className="text-sm text-emerald-600 hover:underline">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-neutral-500">
              Saisissez votre email : nous vous enverrons un lien pour définir un nouveau mot de passe.
            </p>
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-[13px] text-neutral-600">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                     placeholder="Votre email" required className="h-10" data-testid="forgot-email-input" />
            </div>
            <Button type="submit" className="w-full h-10" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </Button>
            <p className="text-center">
              <Link to="/login" className="text-sm text-neutral-500 hover:underline">Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
